import { render } from "./ReceiveCTA.vue?vue&type=template&id=62b08c9a&scoped=true"
import script from "./ReceiveCTA.vue?vue&type=script&lang=js"
export * from "./ReceiveCTA.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-62b08c9a"

export default script